module.exports = __webpack_public_path__ + "img/rupee.2fe39621.svg";